import { sxFontFamily } from "./sxFont";

export const sxTextField = {
  "& .MuiInputBase-root": {
    ...sxFontFamily,
    "font-size": "14px",
    "font-style": "normal",
    "font-weight": "400",
    "border-radius": "50px",
  },
  
};
